<template>
  <generic-modal :title="$t('api key')" ref="generic_modal">
    <div class="title is-5">{{ meta.name }}</div>
    <div class="subtitle is-6 mb-0">
      <span class="icon has-text-info">
        <i class="fa fa-calendar"></i>
      </span>
      <span>{{ format_date_time(meta.create_date) }}</span>
    </div>
    <div class="subtitle is-6">
      <span class="icon has-text-danger">
        <i class="fa fa-calendar"></i>
      </span>
      <span>{{ format_date_time(meta.expire_date) }}</span>
    </div>

    <div class="title is-6" v-if="meta.api_key">
      <p class="box is-family-monospace">{{ meta.api_key }}</p>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <!-- <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button> -->
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
      <button class="button is-rounded is-info" @click="copy_to_clipboard">
        <span class="icon">
          <i class="fa fa-copy"></i>
        </span>
        <span>{{ $t("copy to clipboard") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  success_message,
  get,
  post,
  error_alert,
  format_date_time,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "ApiKeyModal",
  components: { GenericModal },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {},
  methods: {
    format_date_time,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/assistant/api-key", { uuid: uuid })
        .then((element) => {
          v.meta = element;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.error = "";
      // v.uuid = "";
    },
    copy_to_clipboard() {
      let v = this;
      let el = document.createElement("textarea");
      el.value = v.meta.api_key;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      success_message(v.$t("copied to clipboard"));
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
